define([
	"dojo/_base/declare",
	"csi/action/EditController"
], function(declare,EditController) {

	return declare(EditController, {
		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			// summary: add form reset-to-defaults action
			defActions.addAction(this.getProxyAction("ResetToDefaults"));
			defActions.addAction(this.getProxyAction("Save", true, {m_bSubmit: true}));
			this.inherited(arguments);
		}
	});
});